import request, { IResponseData } from "@/utils/request";

interface IPartTimeFactor {
  factor: string;
}

interface IFinalFile {
  file_path: string;
  warnings: Array<string>;
}

export function getPartTimeFactor(): Promise<IResponseData<IPartTimeFactor>> {
  return request.get<IPartTimeFactor>("/personnel_costs/get_part_time_factor");
}

export function updatePartTimeFactor(
  factor: string
): Promise<IResponseData<Record<string, never>>> {
  return request.post<Record<string, never>>(
    "/personnel_costs/update_part_time_factor",
    {
      data: { factor: factor },
    }
  );
}

export function generateFiles(
  taskId: string,
  taskMonth: string
): Promise<IResponseData<IFinalFile>> {
  return request.get("/personnel_costs/merge", {
    params: { task_id: taskId, month: taskMonth },
  });
}
